(function(){
  function swatches(){ try{ var el=document.querySelector('[data-hd-swatches]'); return el?JSON.parse(el.textContent):{} }catch(e){ return {} } }
  var SW=swatches();
  document.querySelectorAll('[data-hd-chips]').forEach(function(list){
    var t=list.getAttribute('data-target');
    var img=document.getElementById(t+'-img'), name=document.getElementById(t+'-name'), buy=document.getElementById(t+'-buy'), note=document.getElementById(t+'-note');
    var label=buy?buy.getAttribute('data-label'):'';
    list.querySelectorAll('.hd-chip').forEach(function(c){
      var n=(c.getAttribute('data-name')||'').toLowerCase(); if(SW[n]) c.style.setProperty('--sw',SW[n]);
    });
    function select(b){
      list.querySelectorAll('.hd-chip').forEach(function(c){c.setAttribute('aria-pressed','false')});
      b.setAttribute('aria-pressed','true');
      var n=b.getAttribute('data-name'), src=b.getAttribute('data-img'), avail=b.getAttribute('data-available')==='true';
      if(name) name.textContent=n;
      if(buy){ buy.href=b.getAttribute('data-url'); buy.setAttribute('data-id',b.getAttribute('data-id')); buy.setAttribute('data-available',String(avail)); buy.textContent=avail?label:'Sold out'; }
      if(note) note.textContent='';
      if(img && src && img.getAttribute('src')!==src){
        img.classList.add('hd-fade');
        var pre=new Image(); pre.onload=function(){ img.src=src; img.removeAttribute('srcset'); img.alt=(img.alt||'').replace(/ in .*$/,' in '+n); img.classList.remove('hd-fade') }; pre.src=src;
      }
    }
    list.addEventListener('click',function(e){ var b=e.target.closest('.hd-chip'); if(!b) return; select(b); });
    var pressed=list.querySelector('.hd-chip[aria-pressed="true"]'); if(pressed) select(pressed);
  });
  function setCount(n){ document.querySelectorAll('[data-hd-cart-count]').forEach(function(el){ el.textContent=n; el.hidden=!(n>0); }); }
  document.querySelectorAll('[data-hd-buy]').forEach(function(buy){
    buy.addEventListener('click',function(e){
      var id=buy.getAttribute('data-id'); if(!id) return;
      if(buy.getAttribute('data-available')!=='true') return; // sold out -> let the link open the product page
      e.preventDefault();
      var note=document.getElementById(buy.id.replace(/-buy$/,'-note'));
      var old=buy.textContent; buy.textContent='Adding…'; buy.style.pointerEvents='none';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return fetch('/cart.js').then(function(c){return c.json()}); })
      .then(function(cart){ setCount(cart.item_count); buy.textContent='Added ✓'; if(note) note.textContent='Added to your cart. Taking you to checkout…'; setTimeout(function(){ window.location.href='/cart'; },500); })
      .catch(function(){ buy.textContent=old; buy.style.pointerEvents=''; window.location.href=buy.href; });
    });
  });
  var v=document.getElementById('hd-reel'), s=document.getElementById('hd-sound');
  if(v&&s){
    s.addEventListener('click',function(){
      v.muted=!v.muted; if(!v.muted){ v.play() }
      s.textContent=v.muted?(s.getAttribute('data-on')||'Sound on'):(s.getAttribute('data-off')||'Sound off'); s.setAttribute('aria-pressed',String(!v.muted));
    });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ var p=v.play(); if(p&&p.catch) p.catch(function(){}) } else { v.pause() } }) },{threshold:.25}).observe(v);
    }
  }
})();
